import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useRateImportStatusReducer = () => useSelector((state: ApplicationState) => state.rateImportStatus);
